import { Request } from '../../Servidor/Request';

export class PropertySituationRequest {
    private sgepsituacaopropriedade: number;
    private nome: string;

	constructor(sgepsituacaopropriedade: number, nome: string) {
		this.sgepsituacaopropriedade = sgepsituacaopropriedade;
		this.nome = nome;
	}


    /**
     * Getter sgepsituacaopropriedade
     * @return {number}
     */
	public getSgepsituacaopropriedade(): number {
		return this.sgepsituacaopropriedade;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PropertySituationStructRequest {
    private sgepsituacaopropriedade: number;

	constructor(sgepsituacaopropriedade: number) {
        this.sgepsituacaopropriedade = sgepsituacaopropriedade;
	}


    /**
     * Getter sgepsituacaopropriedade
     * @return {number}
     */
	public getSgepsituacaopropriedade(): number {
		return this.sgepsituacaopropriedade;
	}

}

export class PropertySituationStructResponse {
    private sgepsituacaopropriedade: number;
    private nome: string;

	constructor(sgepsituacaopropriedade: number, nome: string) {
		this.sgepsituacaopropriedade = sgepsituacaopropriedade;
		this.nome = nome;
	}


    /**
     * Getter sgepsituacaopropriedade
     * @return {number}
     */
	public getSgepsituacaopropriedade(): number {
		return this.sgepsituacaopropriedade;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PropertySituationInteractor {
    public fetchSave(request: PropertySituationRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/situacao-propriedade/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: PropertySituationStructRequest): PromiseLike<PropertySituationStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/situacao-propriedade/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}